import { useContext } from 'react';
import { SystemContext } from '../System';
import { FlightLogger, FlightLoggerContext } from '../metrics/FlightLogger';

export function useFlightLogger(context: FlightLoggerContext): FlightLogger {
  const system = useContext(SystemContext);
  const logger = system.flightLogger;
  logger.setContext(context);
  return logger;
}
